export default __webpack_public_path__ + "static/media/Called Before.67a08acb.mp3";